import { api } from '../../../shared/api/client';

export const getAuthMethods = (bankName) => api.get('bank/getAuthMethods', { params: { bankName } });
export const getBanks = (types = []) => api.get('bank/getBanks', { params: { types } });
export const updateBank = (params) => api.post('/bank/updateBank', params);

export const auth = (params) => api.post('/bank-account/auth', params);
export const addPartner = (data = {}) => api.post('/bank-account/bank-account-private/addPartner', data);
export const deleteBankAccountPrivate = (id) => api.get(
    '/bank-account/bank-account-private/deleteBankAccountPrivate',
    { params: { id } },
);
export const getBankAccountPrivate = (id) => api.get(
    '/bank-account/bank-account-private/getBankAccountPrivate',
    { params: { id } },
);
export const confirmBankAccountApprove = (uuid, bankAccountId) => api.post(
    '/bank-account/confirmBankAccountApprove',
    { bankAccountId },
    { params: { uuid } },
);
export const deleteBankAccount = (uuid) => api.post('/bank-account/deleteBankAccount', {}, { params: { uuid } });
export const getBankAccountDevice = (id) => api.get('/bank-account/device/getBankAccountDevice', { params: { id } });
export const updateBankAccountDevice = (id, params = {}) => api.post(
    '/bank-account/device/updateBankAccountDevice',
    params,
    { params: { id } },
);
export const getBankAccountBusiness = (uuid) => api.get('bank-account/getBankAccountBusiness', { params: { uuid } });
export const getBankAccounts = (params = {}) => api.post('/bank-account/getBankAccounts', params);
export const getBankAccountTransaction = (id) => api.get('bank-account/getBankAccountTransaction', { params: { id } });
export const getBankTransfer = () => api.get('bank-account/getBankTransfer');
export const getBenchName = (uuid, data) => api.post('/bank-account/getBenchName', data, { params: { uuid } });
export const handle = (uuid, cmd) => api.post('/bank-account/handle', { cmd }, { params: { uuid } });
export const requestOtp = (uuid) => api.post('/bank-account/requestOtp', { uuid }, { params: { uuid } });
export const submitOtp = (uuid, data) => api.post(
    '/bank-account/submitOtp',
    { uuid, otp: data?.otp ?? '' },
    { params: { uuid } },
);
export const transfer = (uuid, data) => api.post('/bank-account/transfer', data, { params: { uuid } });
export const updateBankAccount = (data = {}) => api.post('/bank-account/updateBankAccount', data);

export const exportFile = (params, filename) => api.download('/bank-transaction/exportFile', { params, filename });
export const getProcessingPayIns = () => api.get('/bank-transaction/getProcessingPayIns');
export const getTransaction = (uuid, params = {}) => api.post(
    '/bank-transaction/getTransaction',
    params,
    { params: { uuid } },
);
export const getTransactions = (params = {}) => api.post('/bank-transaction/getTransactions', params);
export const searchTransactions = (uuid, params = {}) => api.post(
    '/bank-transaction/searchTransactions',
    params,
    { params: { uuid } },
);
export const updatePayIn = (bankTransactionId, params = {}) => api.post(
    '/bank-transaction/updatePayIn',
    params,
    { params: { bankTransactionId } },
);

export const getLogs = (params = {}) => api.post('admin/log-bank-request/getLogs', params);
